import { render } from "./Seed.vue?vue&type=template&id=0454c130&scoped=true"
import script from "./Seed.vue?vue&type=script&lang=js"
export * from "./Seed.vue?vue&type=script&lang=js"

import "./Seed.vue?vue&type=style&index=0&id=0454c130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0454c130"]])

export default __exports__